import { useState, useEffect } from "react"

const IMG_BASE = "https://image.tmdb.org/t/p/original"

export default function HeroCarousel({ movies, onMovieClick }) {
  const [current, setCurrent] = useState(0)
  const slides = movies.filter((m) => m.backdrop_path).slice(0, 5)

  useEffect(() => {
    if (slides.length === 0) return
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length)
    }, 6000)
    return () => clearInterval(timer)
  }, [slides.length])

  if (slides.length === 0) return null

  return (
    <div className="relative w-full aspect-[21/9] overflow-hidden">
      {slides.map((movie, i) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={`${IMG_BASE}${movie.backdrop_path}`}
            alt={movie.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-950/90 via-zinc-950/50 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent" />

          <div className="absolute inset-0 flex flex-col justify-end px-10 md:px-16 pb-12">
            <div className="flex items-center gap-2 mb-2">
              {movie.vote_average > 0 && (
                <span className="flex items-center gap-1 text-yellow-400 text-sm font-semibold">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  {movie.vote_average.toFixed(1)}
                </span>
              )}
              <span className="text-zinc-400 text-sm">
                {movie.release_date?.split("-")[0]}
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-3 max-w-xl drop-shadow-lg">
              {movie.title}
            </h2>
            <p className="text-zinc-300 text-sm max-w-md line-clamp-2 mb-5 leading-relaxed">
              {movie.overview}
            </p>
            <button
              onClick={() => onMovieClick(movie)}
              className="flex items-center gap-2 w-fit px-6 py-2.5 rounded-lg bg-yellow-400 hover:bg-yellow-300 transition-colors text-zinc-900 font-bold text-sm"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
              Watch now
            </button>
          </div>
        </div>
      ))}

      {/* Dots */}
      <div className="absolute bottom-4 right-6 flex gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === current ? "bg-yellow-400 w-6" : "bg-white/30 w-1.5"
            }`}
          />
        ))}
      </div>
    </div>
  )
}
